import "./SupportRequest.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import BlueLoader from "../loader/BlueLoader";
import "./SupportRequest.css";
import { FileUploader } from "react-drag-drop-files";
import { ImAttachment } from "react-icons/im";
import { SlClose } from "react-icons/sl";
import axios from "axios";
import { useCookies } from "react-cookie";
import globalContext from "../../Contexts/GlobalContext";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import { useNavigate } from "react-router-dom";
import { SERVERMESSAGE } from "../../constants/serverMessage";
import useRequestHeader from "../../hooks/useRequestHeader";
export default function SupportRequest({
  setIsSupportRequest,
  isSupportRequest,
}) {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader("", "multipart/form-data");
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  /////
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState("");

  ////
  const [checkInputs, setCheckInputs] = useState(false);
  const supReqContainer = useRef();
  ////
  const [cookies, setCookies, removeCookies] = useCookies();

  useEffect(() => {
    setCheckInputs(false);
    if (isSupportRequest === "true") {
      supReqContainer?.current?.classList?.remove("supReqDown");
      supReqContainer?.current?.classList?.add("supReqUp");
    } else if (isSupportRequest === "false") {
      supReqContainer?.current?.classList?.remove("supReqUp");
      supReqContainer?.current?.classList?.add("supReqDown");
      setTimeout(() => {
        setIsSupportRequest("");
      }, 500);
    } else {
    }
  }, [isSupportRequest]);

  const sendSuppReq = () => {
    setCheckInputs(true);

    if (message && subject) {
      setIsSending(true);
      const config = {
        headers: requestHeader,
      };
      axios
        .post(
          `${BASE_URL}/ticket/user/set`,
          {
            subject: subject,
            title: subject,
            file: file,
            message: message,
          },
          config
        )
        .then((res) => {
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              setIsSending(false);
              setIsSupportRequest("false");
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(
                SERVERMESSAGE.SUCCESS_TICKET_REGISTER
              );
              setMessage("");
              setSubject("");
              setFile("");
              break;
            }
            default: {
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate
              );
            }
          }
        })
        .catch((err) => {
          setIsSending(false);
          setIsSupportRequest("false");
          setMessage("");
          setSubject("");
          setFile("");
          setCheckInputs(false);
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
        });
    }
  };
  const formData = new FormData();
  /// upload error message state section start ///
  const [upploadErrorMessage, setUpploadErrorMessage] = useState("");
  /// upload error message state section start ///
  const fileTypes = ["JPG", "PNG", "GIF"];
  const handleChange = (file1) => {
    setFile(file1);
    formData.append("file", file1);

    setUpploadErrorMessage("");
  };

  return (
    <>
      <div
        className={`fixed w-full h-screen backdrop-blur-sm  ${
          isSupportRequest ? "" : "hidden"
        }`}
      ></div>
      <div
        ref={supReqContainer}
        className={`w-full h-auto bg-color-primary-B -bottom-[100vw] fixed font-font_primary_A  p-[2vw] rounded-t-[2.8vw] z-[10000] backdrop-blur-sm ${
          isSupportRequest ? "" : "hidden"
        }`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="flex items-center justify-end ">
          <span
            className="ml-[1.5vw] text-[#474747] cursor-pointer z-[800]"
            onClick={() => {
              setIsSupportRequest("false");
            }}
          >
            <IoClose size={25} />
          </span>
        </div>
        <div className="w-full flex flex-col items-center justify-center px-[3vw] gap-y-[1vw]">
          <div className="w-full flex items-center justify-start">
            <label
              htmlFor="subject"
              className="font-font_primary_A text-[4vw] text-[#001D26]"
            >
              موضوع:
            </label>
          </div>
          <input
            autoComplete={"off"}
            type="text"
            value={subject}
            name=""
            id="subject"
            dir="rtl"
            className={`w-full bg-transparent border-[1px] ${
              checkInputs
                ? !subject
                  ? "border-red-600"
                  : "border-[#474747]"
                : "border-[#474747]"
            }  outline-none font-font_primary_A focus:font-font_primary_A text-[3.5vw] focus:text-[3.5vw] rounded-[1.8vw] py-[1vw] px-[4vw]`}
            onChange={(e) => {
              setSubject(e.target.value);
            }}
          />
        </div>
        <div className="relative w-full flex flex-col items-center justify-center mt-[4vw] px-[3vw] gap-y-[1vw]">
          <div className="w-full relative flex items-center justify-between">
            <label
              htmlFor="message"
              className="font-font_primary_A text-[4vw] text-[#001D26]"
            >
              متن درخواست:
            </label>
            <span
              className={`absolute left-[1vw] top-[2vw] font-font_primary_A text-[3vw] ${
                message?.length === 500 ? "text-[#a51b1b]" : "text-[#001D26]"
              }  h-full`}
            >
              {message?.length}/500
            </span>
          </div>
          <textarea
            autoComplete={"off"}
            dir="rtl"
            id="message"
            value={message}
            maxLength={500}
            className={`w-full h-[40vw] outline-none bg-transparent border-[1px] ${
              checkInputs
                ? !message
                  ? "border-red-600"
                  : "border-[#474747]"
                : "border-[#474747]"
            } rounded-[1.8vw] text-[3vw] focus:text-[3vw] py-[1vw] px-[4vw]`}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          ></textarea>
        </div>
        <div className="w-full mt-[4vw] px-[3vw] gap-y-[1vw] ">
          <div className="w-full flex items-center justify-center px-[3vw] gap-y-[1vw] border-[1px] border-[#474747] rounded-[1.8vw] py-[1vw]">
            <div className="w-1/2 flex items-center justify-start">
              <label
                htmlFor="subject"
                className="font-font_primary_A text-[4vw] text-[#001D26] singleLine"
              >
                پیوست:
              </label>
            </div>
            <div
              className={`w-full flex items-center justify-end outline-none`}
            >
              <span
                dir="ltr"
                className="flex items-center justify-center font-font_primary_D text-[3vw] ml-[2vw]"
              >
                {file.name}
              </span>
              {file ? (
                <div
                  className=" left-0 w-auto flex items-center justify-center"
                  onClick={() => {
                    setFile("");
                  }}
                >
                  <SlClose size={20} color="#a51b1b" />
                </div>
              ) : (
                <div className="bottom-[1vw] left-0">
                  <FileUploader
                    name="file"
                    handleChange={handleChange}
                    multiple={false}
                    types={fileTypes}
                    maxSize={2}
                    onSizeError={() => {
                      setUpploadErrorMessage(
                        "حجم فایل باید کمتر از 2 مگابایت باشد"
                      );
                    }}
                  >
                    <div className="w-auto h-full flex items-center justify-center">
                      <ImAttachment size={20} color="white" />
                    </div>
                  </FileUploader>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-full flex items-center justify-center mt-[4vw] mb-[2vw]  ">
          <button
            disabled={isSending}
            className="w-[50vw] h-[10vw] font-font_primary_A bg-[#001D26] text-[#FFF] rounded-[1.8vw] flex items-center justify-center "
            onClick={sendSuppReq}
          >
            {isSending ? <BlueLoader position="" width={8} /> : "ارسال"}
          </button>
        </div>
      </div>
    </>
  );
}
